import React from 'react';
import HostForm from '../../components/host/HostForm';

const EditHostPage = () => {
  return (
    <div>
      <HostForm editMode={true} />
    </div>
  );
};

export default EditHostPage;